import type { ExtractPropTypes, PropType } from 'vue'
import { radioProps } from './radio'

export type RadioGroupSize = 'large' | 'default' | 'small'

export const radioGroupProps = {
  /**
   * 绑定值
   */
  modelValue: {
    type: [String, Number, Boolean],
    default: ''
  },
  /**
   * 是否禁用
   */
  disabled: {
    type: Boolean,
    default: false
  },
  /**
   * 单选框组尺寸
   */
  size: {
    type: String as PropType<RadioGroupSize>,
    default: ''
  },
  /**
   * 单选框组的名称
   */
  name: {
    type: String,
    default: ''
  },
  /**
   * 按钮形式的 Radio 激活时的文本颜色
   */
  textColor: {
    type: String,
    default: '#ffffff'
  },
  /**
   * 按钮形式的 Radio 激活时的填充色和边框色
   */
  fill: {
    type: String,
    default: '#409EFF'
  }
} as const

export const radioGroupEmits = {
  'update:modelValue': (val: string | number | boolean) => true,
  'change': (val: string | number | boolean) => true
}

export type RadioGroupProps = ExtractPropTypes<typeof radioGroupProps>
export type RadioGroupEmits = typeof radioGroupEmits